import { useState, useEffect } from "react";
import Icon from "../assets/icon.png";

const Toast = (props) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShow(false);
    }, 3000);
  }, []);

  return (
    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 999 }}>
      <div
        id="liveToast"
        className={show ? "toast show" : "toast hide"}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="toast-header rounded">
          <img src={Icon} className="me-3" alt="icone" height={20} />
          <span className="me-auto">{props.header}</span>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="toast"
            aria-label="Close"
            onClick={() => setShow(false)}
          ></button>
        </div>
        {props.body && <div className="toast-body">{props.body}</div>}
      </div>
    </div>
  );
};

export default Toast;
